import React from 'react'
import { getHexColor, OneColorIconProps } from '@/atoms/utils'

export const TorchIcon: React.FC<OneColorIconProps> = ({ color = 'white', size = 56 }) => {
  const c = getHexColor(color)

  return (
    <svg width={size} height={size} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.2 31.5c0-4.667.792-7.607 4.675-11.667m0 0C37.758 15.773 35.33 8.58 32.706 7c-1.088 5.263-3.505 8.167-5.91 11.175.068-4.175-1.871-6.418-4.606-7.675-1.076 2.778-3.672 6.945-6.901 9.722C11.733 23.282 7 26.112 7 35c0 8.889 5.842 16.333 16.359 16.333 9.473 0 17.527-6.055 17.527-16.333 0-12.833 11.684-15.167 7.01-30.333-2.29 6.828-7.01 9.333-14.021 15.166Z"
        stroke={c}
        strokeWidth="4.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
